import { Component, Input, OnInit } from '@angular/core';
import { DealerProfile } from '@app/domain/model/dealer-profile';
import { DealerLicenseStatus } from '@app/domain/model/dealer-license-status';
import { MarketType } from '@app/domain/model/market-type';

@Component({
  selector: 'app-dealer-profile',
  templateUrl: './dealer-profile-view.component.html',
  styleUrls: ['./dealer-profile-view.component.scss']
})
export class DealerProfileViewComponent implements OnInit {

  @Input()
  profile: DealerProfile;

  public DealerLicenseStatus: typeof DealerLicenseStatus = DealerLicenseStatus;

  public MarketType: typeof MarketType = MarketType;

  constructor() {
  }

  ngOnInit() {
  }

}
